import request from '@/utils/request'
const BASE_URL = '/Rep'

export default {
  repOrderSum(data) {
    return request({
      url: BASE_URL + '/RepOrderSum',
      method: 'post',
      data
    })
  },
  repProduceSum(data) {
    return request({
      url: BASE_URL + '/RepProduceSum',
      method: 'post',
      data
    })
  },
  repOutProcSum(data) {
    return request({
      url: BASE_URL + '/RepOutProcSum',
      method: 'post',
      data
    })
  },
  repPurchasSum(data) {
    return request({
      url: BASE_URL + '/RepPurchasSum',
      method: 'post',
      data
    })
  },
}